import { APP } from './Utils/Constants.js'
import {FC, useContext, useEffect} from "react";
import { useOriginalDatas } from './Hooks/useOriginalDatas.ts';

import { FiltersProvider } from "./Context/FiltersContext.tsx";
import {DataPageContext} from "./Context/DataPageContext.tsx";

import '../css/Catalog.css'

import Items from "./Components/Items.tsx";
import Loader from "./Components/Loader.tsx";
import Filters from "./Components/Filters.tsx";
import ReactDOM from "react-dom";
import CatalogHeader from "./Components/Filters/CatalogHeader.tsx";

interface AppProps  {
  dataPage: string
  link: string
  linkLabel: string
}
const App: FC<AppProps> = ({dataPage, link, linkLabel}) => {

  const { setDataPage } = useContext(DataPageContext);

  useEffect(() => {
    setDataPage(dataPage);
  }, []);

  const { originalDatas, dataStatus } = useOriginalDatas();

    const RenderSidebar = () => {
        return (
            <div key="app-sidebar" className="catalog-filters">
                <Filters
                    originalDatas = {originalDatas}
                />
              <a href={link} className="link-with-aria catalog-redirect">
                {linkLabel}
                <i className="icon-arrow-right" aria-hidden="true"></i>
              </a>
            </div>
        );
    };

  const RenderMainContent = () => {
        return (
            <div key="app-main-content" className="catalog-list last">
                {APP.STATUS.FILTERING === dataStatus ? <Loader>
                    {Drupal.t('Application des filtres')}
                </Loader> : [
                    <Items key="item" type_formation={originalDatas.typeFormation}/>,
                ]}
            </div>
        );
    };

  return (
      <FiltersProvider>
        <div className="catalog-wrapper">
          {APP.STATUS.LOADING === dataStatus ? (
            <Loader className="col-12">{Drupal.t('Chargement en cours')}</Loader>
          ) : (
            <>
              {/* Rendu de RenderSidebar dans un élément spécifique du DOM */}
              {document.getElementById('catalog-filters') && (
                ReactDOM.createPortal(
                  <RenderSidebar/>,
                  document.getElementById('catalog-filters')!
                )
              )}

              {/* Rendu de RenderMainContent dans l'élément principal */}
              <CatalogHeader/>
              <RenderMainContent/>
            </>
          )}
        </div>
      </FiltersProvider>
  );
}

export default App
